import { Mapping } from 'api/MappingsAPI';
import { useSearchParamsContext } from 'modules/dataDictionary/contexts';
import { FieldType } from 'modules/domains';
import { useMemo } from 'react';
import { paginate } from 'utils/arrayHelpers';
import { usePaginationContext } from 'utils/contexts/pagination';
import { filterMappings } from '../utils';

type Props = {
  mappings: Mapping[];
};

export const useFieldTable = ({ mappings }: Props) => {
  const { debouncedSearch, visibility } = useSearchParamsContext();
  const { currentPage, pageSize: itemsPerPage } = usePaginationContext();

  /**
   * Names of all mappings that are of Object type
   * Used to change the display of the field name
   */
  const objectMappingNames = mappings
    .filter((field) => [FieldType.OBJECT, FieldType.NESTED].includes(field.fieldType))
    .map((field) => field.fieldName);

  /**
   * Filter and sort the mappings based on the search and visibility
   */
  const filteredMappings = useMemo(
    () => filterMappings(mappings, debouncedSearch, visibility),
    [debouncedSearch, mappings, visibility],
  );

  /**
   * Paginate the filtered mappings
   */
  const paginatedMappings = useMemo(
    () => paginate(filteredMappings, itemsPerPage, currentPage),
    [currentPage, filteredMappings, itemsPerPage],
  );

  return {
    filteredMappings,
    objectMappingNames,
    paginatedMappings,
  };
};
